export const CAUHINHDANHMUC_SET_LIST_DATA = 'CAUHINHDANHMUC_SET_LIST_DATA';
export const CAUHINHDANHMUC_SET_LIST_META = 'CAUHINHDANHMUC_SET_LIST_META';
export const CAUHINHDANHMUC_TITLE = 'Cấu hình trường danh mục';